import React, { Component } from 'react';
import { connect } from "react-redux";
import IdleTimer from "react-idle-timer";
import { redirectToAnotherApplication, extendSession } from "../../actions/crossSellApplicationActions";
import { getUrl, isMobileChannel } from "../../utils/is.after";
import "./sessionTimeout.scss";
import { scrollToTop } from "../../utils/is.after";

let INITIAL_IDLA_CHECK_VALUE = 30*1000;
let ABOUT_TO_TIMEOUT_VALUE = (19*60*1000) - INITIAL_IDLA_CHECK_VALUE;
let INITIAL_IDLA_CHECK = "INITIAL_IDLA_CHECK";
let ABOUT_TO_TIMEOUT = "ABOUT_TO_TIMEOUT";
const DEFAULT_COUNTER = 60;

class SessionTimeout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: 1,
      counter: DEFAULT_COUNTER,
      inactiveHeader: false,
      timeoutValues: INITIAL_IDLA_CHECK_VALUE,
      apiCallStaus: INITIAL_IDLA_CHECK
    };
    this.handleIdleTimer = null;
    this.handleCounter = this.handleCounter.bind(this);
  }

  componentDidMount() {
    this.handleApiCounter();
  }

  componentWillReceiveProps(newProps){
    if (this.state.level !== newProps.info.level || newProps.isLoading) {
      this.handleIdleTimer = null;
      this.setState({ inactiveHeader: false,
        counter: DEFAULT_COUNTER,
        timeoutValues: INITIAL_IDLA_CHECK_VALUE,
        apiCallStaus: INITIAL_IDLA_CHECK });
      clearInterval(this.counterInterval);
      clearInterval(this.apiCounterInterval);
      this.handleApiCounter();
      this.setState({ level: newProps.info.level });
    }
  }

  handleApiCounter=()=>{
    this.apiCounterInterval = setInterval(() => {
      this.setState({ apiCallStaus: ABOUT_TO_TIMEOUT });
    }, ABOUT_TO_TIMEOUT_VALUE);
  }

  handleCounter(){
    let count=0;
    let lastTime=new Date();
    this.counterInterval= setInterval(()=>{
      count+=Date.now()-lastTime.getTime();
      lastTime=new Date();
      let countValue=DEFAULT_COUNTER-Math.floor(count/1000);
      this.setState({ counter: countValue });
      if(countValue <= 0){
        this.handleSessionTimeout();
        clearInterval(this.counterInterval);
      }
    }, 250);
  }

  handleSessionTimeout = () => {
    let ssoReferrerUrl = this.props.offerPreFilled.ssoReferrer;
    if(isMobileChannel(this.props.offerPreFilled.channelSource)){
      this.props.redirectURL(ssoReferrerUrl);
    }else{
      this.props.redirectURL(getUrl(ssoReferrerUrl, "timeout"));
    }
  };

  handleExtendSession = () => {
    this.handleRefreshSession();
    this.setState({ timeoutValues: INITIAL_IDLA_CHECK_VALUE, apiCallStaus: INITIAL_IDLA_CHECK });
    this.handleIdleTimer = null;
  };

  handleRefreshSession = () => {
    this.props.extendSession();
    this.setState({ inactiveHeader: false, counter: DEFAULT_COUNTER });
    clearInterval(this.counterInterval);
    clearInterval(this.apiCounterInterval);
  };

  handleOnIdle = ()=>{
    if(this.state.timeoutValues === INITIAL_IDLA_CHECK_VALUE){
      this.handleRefreshSession();
      this.setState({ timeoutValues: ABOUT_TO_TIMEOUT_VALUE });
      this.handleIdleTimer= null;
    }else{
      this.setState({ inactiveHeader: true });
      scrollToTop();
      this.handleCounter();
    }
  }

  handleonAction=()=>{
    if((this.state.apiCallStaus === ABOUT_TO_TIMEOUT) && (!this.state.inactiveHeader)){
      this.handleExtendSession();
    }
    if(this.state.timeoutValues ===ABOUT_TO_TIMEOUT_VALUE) {
      this.setState({ timeoutValues: INITIAL_IDLA_CHECK_VALUE });
    }
  }

  render() {
    return(
      <div>
        <IdleTimer
          ref={ref => { this.handleIdleTimer = ref; }}
          timeout={this.state.timeoutValues}
          onAction={this.handleonAction}
          onIdle={this.handleOnIdle}></IdleTimer>
        {this.state.inactiveHeader?
          <div className="sessionContainer">
            <span>You will be logged out in <span className="counter">{this.state.counter}</span> seconds due to inactivity. </span>
            <button className="btn btn-session" onClick={this.handleExtendSession}>Keep me signed in</button>
          </div>:null}
      </div>
    );
  }
}

const mapDispatchToProps = { redirectURL: redirectToAnotherApplication, extendSession };
export default connect('', mapDispatchToProps)(SessionTimeout);
